import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
// import { UserService } from '../../../../../shared/services/user.service';
// import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { AppService } from '../../../../app.service';
import { SelectionLists, CurrentSelection, Customer, JobSite, Equipment } from '../../../../entities';
import { Router } from '@angular/router';
import { TranslateService } from '../../../../translate';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../../../../shared/services/user.service';
import { ManageEquipmentService } from '../../../manage-equipment/manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';

@Component({
  selector: 'app-find-inspected-equipment-popup',
  templateUrl: './find-inspected-equipment-popup.component.html',
  styleUrls: ['./find-inspected-equipment-popup.component.scss']
})
export class FindInspectedEquipmentPopupComponent implements OnInit {

  //Title = 'Select equipment to create new inspection';

  translateSubscription: Subscription;
  userLanguage = 'english';
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = '';
  _selectedEquipment: Equipment = new Equipment();
  isloading = true;
  selectedJobsite: JobSite;
  equipmentSelected: boolean;

  newInspection = false;

  isInspector: boolean;
  isInterpreter: boolean;
  IsRopeShovel:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<FindInspectedEquipmentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _loading: LoadingService,
    private _appService: AppService,
    private _router: Router,
    private _translate: TranslateService,
    private _userService: UserService,
    private ref: ChangeDetectorRef, private _equipmentService: ManageEquipmentService,
  ) { }

  ngOnInit() {
    this.isloading = true;
    this.newInspection = this.data.fromMenu;
    this._loading.startLoading();
    this.loadUserJobRoles();
    this.CheckAddNewIspectionMenuAccess();
    const customers = this._appService.getCustomerListForSelection(1, 10000);
    const jobsites = this._appService.getJobSiteListForSelection(1, 10000);
    const equipments = this._appService.getEquipmentListForSelection(1, 10000);

    Observable.forkJoin([customers, jobsites, equipments]).subscribe(results => {
      this._dropDownLists.customerList = results[0];
      this._dropDownListsFiltered.customerList = results[0];
      this._dropDownLists.jobSiteList = results[1];
      this._dropDownLists.equipmentList = results[2];
      this._loading.finishedLoading();
      this.isloading = false;
    });
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    // this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result; }, error => { console.error(error); }, () => { });
    // this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this._dropDownLists.jobSiteList = result; }, error => { console.error(error); }, () => { });
    // this._appService.getEquipmentListForSelection(1, 10000).subscribe(result => { this._dropDownLists.equipmentList = result; }, error => { console.error(error); }, () => { });
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
}
  customerChanged(event: any): void {
    const customer: Customer = event.value;
    if (!customer) return;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
    this._currentSelection.jobSite = new JobSite();
    this._dropDownListsFiltered.equipmentList = [];
    this._currentSelection.equipment = new Equipment();
    this.equipmentSelected = false;
    this.noComponents = false
  }

  jobsiteChanged(event: any): void {
    const jobsite: JobSite = event.value;
    if (!jobsite) return;
    this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId === jobsite.Id);
    this._currentSelection.equipment = new Equipment();
    this.equipmentSelected = false;
    this.noComponents = false
  }

  equipmentChanged(event: any): void {
    this._selectedEquipment.Id = event.value.Id;
    this._selectedEquipment.JobSiteId = event.value.JobSiteId;
    this._selectedEquipment.Serial = event.value.Serial;
    this._selectedEquipment.Unit = event.value.Unit;
    this._selectedEquipment.FamilyId=event.value.FamilyId;
  
   if(this._selectedEquipment.FamilyId ==203){
    this.IsRopeShovel=true;
   }else{
    this.IsRopeShovel=false;
     const today = new Date();
    this._equipmentService.getEquipmentSystems(this._selectedEquipment.Id,moment(today).format('MM/DD/YYYY')).subscribe(res=>{
      let systemDetails = res;
      console.log("systemDetails",systemDetails)
      if(systemDetails.length==0 || systemDetails ==null){
        console.log("NO")
        this.noComponents = true
      }else{
        console.log("HAS")
        this.noComponents = false;
      }
    })
   }
   
    this.equipmentSelected = true;
  }
  onNoClick() {
    this.dialogRef.close();
  }
  noComponents:boolean=false;
  selectEquipment() {
    this.dialogRef.close();
    // this._router.navigate(["add-new-inspection", { equipmentId: this._selectedEquipment.Id }]);
      this._router.navigate(['add-new-inspection', this._selectedEquipment.Id , 0]);
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  CheckAddNewIspectionMenuAccess(){
    this._userService.CheckAddNewIspectionMenuAccess().subscribe(res=>{
      if(res==true){
        this.isInspector = true;
      }else{
        this.isInspector = false;
      }
    })
  }
  loadUserJobRoles() {
    this._loading.startLoading();
    this._userService.getUserJobRoles().subscribe(roles => {
        roles.forEach(r => {
            switch (r.Name) {
                case 'Inspectors':
                    this.isInspector = true;
                    break;
                  case 'Undercarriage ONLY':
                      this.isInspector = true;
                      break;
                case 'Interpreters':
                    this.isInterpreter = true;
                    break;
                case 'Super User':
                case 'Administrator':
                    this.isInspector = true;
                    this.isInterpreter = true;
                    break;
                    case 'Customer Admin':
                      this.isInspector = true;
                    this.isInterpreter = true;
                      break;
            }
        });
        this._loading.finishedLoading();
    });
}
}
